export const labels = {
  CUSTOMER: 'Заказчик',
  KITCHEN: 'Кухня',

  BREAKFAST: 'Завтрак',
  LUNCH: 'Обед',
  SNACK: 'Полдник',
  DINNER: 'Ужин',

  DRAFT: 'Черновик',
  SUBMITTED: 'Отправлен',

  SUBSET: 'Подмножество',
  ADDITIONAL: 'Дополнительно',

  DIET: 'Диета',
  EXCLUDE: 'Исключить',
  ALLERGEN: 'Аллерген',
  OTHER: 'Другое'
}

export function label (key) {
  return labels[key] || key
}
